import React, {Component} from 'react';
import {connect} from 'react-redux';
import Slate from './slate';
import LateSwap from './late-swap';
import ThemeSwitcher from 'components/molecules/theme-switcher';

class IndexComponent extends Component {
    render() {
        const {sportConfig} = this.props;

        return (
            <>
                <ThemeSwitcher />
                {sportConfig.isModeLateswap() ? <LateSwap /> : <Slate />}
            </>
        );
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(IndexComponent);
